/**
 * Keep track of all Kameleoon experiments.
 * Remember to remove related code when the experiment is done.
 */
export enum ActiveExperiments {
  MobileTimetableOnlyUK = 'MOBILE_TIMETABLE_ONLY_UK',
  MobileTimetableOnlyFR = 'MOBILE_TIMETABLE_ONLY_FR',

  DiscountBannerPCT = 'DISCOUNT_BANNER_PCT_V2',

  HeroSectionRemoveInputsFR = 'HERO_SECTION_REMOVE_INPUTS_FR',

  EWOShockPricingUK = 'EWO_SHOCK_PRICING_UK',
  EWOShockPricingFR = 'EWO_SHOCK_PRICING_FR',

  PaymentMethodSecureFR = 'PAYMENT_METHOD_SECURE_FR',

  ServicingQuotesPriceMatchPromiseUK = 'SERVICING_QUOTES_PRICE_MATCH_PROMISE_UK',

  VidangeUpsellFR = 'VIDANGE_UPSELL_FR',

  MotServicingQuotesPageUK = 'MOT_SERVICING_QUOTES_PAGE_UK',

  CustomerCnDOnlyPopUp = 'CUSTOMER_C_N_D_ONLY_POP_UP',

  KlarnaFakeDoorInCheckoutFlowUK = 'KLARNA_FAKE_DOOR_IN_CHECKOUT_FLOW_UK',
}
